import styled from 'styled-components';
import { lt } from '@mews/framework';
import { ClickableDiv, Icon, IconName, Stack } from '@optimus-web/core';

export interface TimelinePaginationProps {
    onPrevFast: () => void;
    onPrev: () => void;
    onToday: () => void;
    onNext: () => void;
    onNextFast: () => void;
}

export const TimelinePagination: React.FC<TimelinePaginationProps> = ({
    onPrevFast,
    onPrev,
    onToday,
    onNext,
    onNextFast,
}) => (
    <Stack spacing="50" itemAlignment="center" alignment="center">
        <ClickableDiv onClick={onPrevFast}>
            <StyledIcon value={IconName.FastBackwardSimple} />
        </ClickableDiv>
        <ClickableDiv onClick={onPrev}>
            <StyledIcon value={IconName.Backward} />
        </ClickableDiv>
        <ClickableDiv onClick={onToday}>{lt('Today')}</ClickableDiv>
        <ClickableDiv onClick={onNext}>
            <StyledIcon value={IconName.Forward} />
        </ClickableDiv>
        <ClickableDiv onClick={onNextFast}>
            <StyledIcon value={IconName.FastForwardSimple} />
        </ClickableDiv>
    </Stack>
);

const StyledIcon = styled(Icon)`
    vertical-align: middle;
`;
